import { Component, Input } from "@angular/core";
import { ProductMtaAgreementModel } from "../../../models/components/product-mta-agreement.model";

@Component({
    selector: "pcg-ng-product-mta-agreement",
    template: require('./product-mta-agreement.component.html')
})
export class ProductMtaAgreementComponent {
    @Input()
    public agreement: ProductMtaAgreementModel;

    public allowProceed: boolean = false;

    public onDownloadClick(e: Event): void {
        this.allowProceed = true;
    }
}
